module.exports = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000/v1',
  // REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://172.16.50.182:8000/v1',
  PORT: process.env.PORT || '3002',
  HCAPTCHA_SITE_KEY: '4a6d11a8-bb08-42a7-ba8d-bbc1d802c81a',
  NODE_ENV: process.env.NODE_ENV,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY || 'pk_test_ecHsiw8fixGWjZ7HwmP5bk3y00gwo2VxfK'
};
